<template>
  <v-dialog :value="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
      </v-toolbar>

      <iframe v-if="pdf" :src="pdf" frameborder="0" class="espelho-ponto-pdf" />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EModalEspelhoPontoPdf",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    pdf: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "Espelho de ponto",
    },
  },
};
</script>

<style scoped>
.espelho-ponto-pdf {
  width: 100%;
  height: calc(100vh - 64px);
}
</style>
